import React from 'react';
import { View, Text, StyleSheet, Platform, Image, TouchableOpacity, ImageStyle, ViewStyle, TextStyle } from 'react-native';
import Ionicons from '@expo/vector-icons/Ionicons';
import { colors, layout, typography } from '../styles';
import { Typography } from './ui';
import { useTheme } from '../context/ThemeContext';
import { useI18n } from '../i18n';

import { ACCENT_TEXT } from '../styles/accentText';
export const VideoBlock: React.FC = () => {
  const { colors: themeColors } = useTheme();
  const { t } = useI18n('home');
  return (
    <View style={[styles.section, { backgroundColor: themeColors.canvas }]}>
      <View style={styles.container}>
        <TouchableOpacity style={styles.videoWrapper} activeOpacity={0.9}>
          <Image
            source={require('../../assets/zadom33.png')}
            style={styles.videoImage as ImageStyle}
          />
          <View style={styles.overlay} />
          <View style={styles.playButtonContainer}>
            <View style={styles.playButton} className={Platform.OS === 'web' ? 'convex-glass-fire' : ''}>
              <Ionicons name="play" size={40} color="#FFFFFF" style={styles.playIcon} />
            </View>
          </View>
          <View style={styles.textOverlay}>
            <Typography variant="h2" style={styles.title}>
              {t('videoBlock.title')}{'\n'}
              <Text style={{ color: ACCENT_TEXT }}>{t('videoBlock.titleHighlight')}</Text>
            </Typography>
          </View>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  section: {
    paddingTop: 20,
    paddingBottom: 60,
    backgroundColor: '#FFFFFF',
  } as ViewStyle,
  container: {
    maxWidth: layout.maxWidth,
    marginHorizontal: 'auto',
    paddingHorizontal: layout.paddingH,
    width: '100%',
  } as ViewStyle,
  videoWrapper: {
    position: 'relative',
    width: '100%',
    aspectRatio: Platform.OS === 'web' ? 2.33 : 1.3,
    borderRadius: 48,
    overflow: 'hidden',
    backgroundColor: '#2B2730',
    boxShadow: '0 40px 120px rgba(0,0,0,0.1)',
  } as any,
  videoImage: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    resizeMode: 'cover',
  },
  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(15, 20, 25, 0.2)',
  } as ViewStyle,
  playButtonContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    alignItems: 'center',
    justifyContent: 'center',
  } as ViewStyle,
  playButton: {
    width: 120,
    height: 120,
    borderRadius: 60,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: 'rgba(255, 255, 255, 0.4)',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    backdropFilter: 'blur(20px)',
  } as any,
  playIcon: {
    marginLeft: 8,
  },
  textOverlay: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    padding: 64,
  } as any,
  title: {
    ...typography.sectionTitle,
    color: '#FFFFFF',
  } as TextStyle,
});
